import React from "react";
import "components/ImageViewer/ImageViewer.css";
import PropTypes from "prop-types";
function ImageViewer({ className = "", src, alt }) {
  return (
    <div className={"image-viewer " + className}>
      <img src={src} alt={alt} />
    </div>
  );
}
ImageViewer.propTypes = {
  className: PropTypes.string,
  src: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired,
};
export default ImageViewer;
